import $ from "jquery";

var mailchimp = function(){
  $(document).ready(function () {
    var $form = $('#mc-embedded-subscribe-form')
    if ($form.length > 0) {
      $('#mc-embedded-subscribe-form input[type="submit"]').bind('click', function (event) {
        if (event) event.preventDefault()
        register($form)
      })
    }
  })

  function register($form) {
    // $('#mc-embedded-subscribe').val('Sending...');
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: function (err) { alert("Sorry we can't sign you up right now. Please try again later.") },
      success: function (data) {
        // $('#mc-embedded-subscribe').val('&rarr;')
        if (data.result === 'success') {
          // Yeahhhh Success
          console.log(data.msg)
          $('#mce-EMAIL').css('borderColor', '#b8e986')
          $('#subscribe-result').css('color', '#b8e986')
          $('#subscribe-result').html("<p>Thanks for signing up to our newsletter.</p>")
          $('#mce-EMAIL').val('')
        } else {
          // Something went wrong, do something to notify the user.
          console.log(data.msg)
          $('#mce-EMAIL').css('borderColor', '#ff8282')
          $('#subscribe-result').css('color', '#ff8282')
          $('#subscribe-result').html('<p>' + data.msg.substring(4) + '</p>')
        }
      }
    })
  };
}

export default mailchimp;



// WEBPACK FOOTER //
// ./src/scripts/functions/mailchimp.js